export default "__VITE_ASSET__BAz6FQT___"